<template>
    <div class="closer">
        x
    </div>
</template>
<script>
    export default {
        name: 'Closer'
    }
</script>
<style scoped>

</style>